// A name with what the search matched marked (Add a meal, All items).
export function Highlight({ text, query }: { text: string; query: string }) {
  const q = query.trim().toLocaleLowerCase()
  const at = q ? text.toLocaleLowerCase().indexOf(q) : -1
  if (at < 0) return <>{text}</>
  return <>{text.slice(0, at)}<mark className="ml-mark">{text.slice(at, at + q.length)}</mark>{text.slice(at + q.length)}</>
}
